const $inject = ['$http', 'dataService'];

const lbaTestFtpConnectionCtrl = function ($http, dataService) {
  let vm = this;
  vm.errorMessage = '';

  function createRequest() {
    let data = dataService.data.activeItem;
    return {
      CompanyReferenceConfigId: data.Id,
      FtpHost: data.FtpHost,
      FtpPort: data.FtpPort,
      FtpUserName: data.FtpUserName,
      FtpPassword: data.FtpPassword,
      IsSFtp: data.IsSFtp,
      FileName: data.FileName,
      FilePath: data.FilePath
    };
  }

  vm.onClick = function (){
    vm.errorMessage = ' Testing Connection...';
    let endPointController = vm.settings.endPointController;
    var url = `${endPointUrl}/${endPointController}`;

    let request = createRequest();
    $http.post(url, request)
    .success((response, status, headers) => {
      var connected = response.CanConnect;
      if(!connected){
        vm.errorMessage = response.ErrorMessage;
        return;
      }
      vm.errorMessage = 'Successfully Connected';
      if(response.FileExist===false){
        vm.errorMessage += ', File not found';
      }else if(response.FileExist===true){
        vm.errorMessage += ', File found';
      }
    })
    .error((data, status) => {
      vm.errorMessage = 'An error occurred when calling the url ' + url + '.  Return code: ' + status;
    })
  }
};

lbaTestFtpConnectionCtrl.$inject = $inject;

export default lbaTestFtpConnectionCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaTestFtpConnection/lbaTestFtpConnectionCtrl.js